module.exports = __webpack_public_path__ + "static/img/h-i-3.9608756f.png";